<template>
  <div class="fixed footer">
    <div class="order-page bg-gray" v-if="curPage=='order-page'">
      <div class="flex flex-center bg-secondary">

        <div @click="showShoppingCart" class="flex flex-center shopping-cart flex1 bg-main">

          <div v-if="!cart_qty"  class="left-cart-icon" >
            <v-icon class="shopping-cart-icon empty-cart-icon whiteIcon">
              {{ icons.mdiCartVariant }}
            </v-icon>
          </div>
          <div v-if="cart_qty"  class="left-cart-icon" @click="openCart">
            <v-btn icon text class="shopping-cart-icon" >
              <v-badge v-if="cart_qty" color="transparent" dot light style="position:relative">
                <div  class="badge" >
                  {{ cart_qty }}
                </div>
                <v-icon class="whiteIcon" size="25">{{ icons.mdiCartVariant }}</v-icon>
              </v-badge>
            </v-btn>
          </div>

          <div class="view-cart" @click="addOrder">
            {{ $t("translate.checkout") }}
          </div>
          
          <div class="subtotal" @click="addOrder">RM {{cart_subtotal || 0}}</div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { mdiCartVariant } from '@mdi/js'; 
import { indexPage, validateBusinessAndHoliday } from '@/api/api'
export default {
  props: {
    pageName: {
      type: String,
      default: 'order-page'
    },
    pageData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      store: {},
      isDine: false,
      indexPage: {},
      plusContent:0,
      curPage: '',
      pageType: '',
      icons: {
          mdiCartVariant
        }
    }
  },
  computed: {
    ...mapGetters([
      'cart_qty', 'cart_subtotal', 'store_info'
    ])
  },
  created () {
    this.curPage = this.pageName
  },
  methods: {
    ...mapActions({ resetShowCart: 'shoppping_cart/showShoppingCart' }),
    showShoppingCart () {
      // this.$emit("evtShowShoppingCart", true)
      this.resetShowCart(true)
    },

    openCart(){
      this.$emit("evtOpenCart")
    },
    addOrder () {
      // this.$router.push('/cart')
      // const url = { path: 'cart', query: { plan: 'private' }}
      // const url = { name: 'cart', params: { userId: 123 }}
      //  this.$router.push(url)
      const getRouteQuery = () => {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'validateBusinessAndHoliday' 
      return tempParams
      }
      const updateOption = () => {
      const queryParams = Object.assign(getRouteQuery(), {storeid: this.store_info.id});
      console.log('queryParams', queryParams)
      validateBusinessAndHoliday("/app/index.php", queryParams)
              .then(res => {
                this.indexPage = res.data
                this.store = this.indexPage.store
                this.isDine = this.indexPage.isDineIn
                console.log('is Dine In ', this.isDine)
                console.log('res received', res.data)

                const table_type = this.store_info.table_type
                console.log('The store is rest >>> ',this.store.is_rest)
                if (this.store.is_24_hours_operation == 0 && this.store.is_rest == 0 || this.store.is_show != 1) {
                this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                } else if (this.isDine && this.store.is_rest == 0 || this.store.is_show != 1){
                  this.$toast("Merchant is not operating, please try again later!")
                } else {
                    if (table_type && this.store_info[table_type] == 0) {
                        this.$toast(this.store_info.table_type_error)
                    } else{
                        this.$emit("evtCompleteOrder");
                    }
                }
              })
              .catch(error => {
                // console.log('添加到购物车.error', error);
              });
      };
      updateOption();
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.footer {
  font-family: Arial;
  transition: all .8s cubic-bezier(1,.04,.12,.96);
  transform: translateY(100%);
  z-index: 900;
  left: 0;
  right: 0;
  bottom: 0;
  @media (max-width: 950px){
    transform: translateY(0);
    }
  

.shopping-cart {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 480px) {
  _::-webkit-full-page-media, _:future, :root .safari_only {
      // height: 65px;
      // padding-bottom: 65px; //resize 
      height: 70px;
      padding-bottom: 10px;
    }
  }
}

}

.left-cart-icon{
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 76px;
}  
.left-cart-icon:hover{
    background-color: @brown1;
}
.left-cart-icon:active{
    background-color:@brown1;
}


.shopping-cart-icon{
  background-color: rgba(97, 97, 97, 0.466);
  border-radius: 50%;
  cursor: pointer;
  padding:18px
}

.empty-cart-icon{
  cursor: not-allowed;
  background-color: transparent;
}

.icart {
  background-color: @gray1;
  border-radius: 50%;
  padding: 8px;
  position: absolute;
  top: -10px;
  color: @fff;
}

.subtotal {
  height: 60px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: bold;
  }
}

.subtotal:hover{
  background-color: rgba(224, 224, 224, 0.301);
}

.subtotal:active{
  background-color: rgba(109, 109, 109, 0.301);
}

.view-cart{
  height: 60px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  font-family:Arial;
}

.view-cart:hover{
  background-color: rgba(224, 224, 224, 0.301);
}

.view-cart:active{
  background-color: rgba(109, 109, 109, 0.301);
}

.badge{
  color: @fff;
  position: absolute;
  top: -15px;
  left: 15px;
  font-size: 13px;
  background-color: @brown2;
  border-radius: 50%;
  padding:7px 5px;
  z-index: 10;
  @media only screen and (min-width: 950px) {
    // display: none;
  }
}

</style>
